<div class="item-container d-flex flex-column">
    <div class="item-header">
        <h6 class="text-center">{{'COMMON.ADD' | translate}} {{"COMMON.NOTES" | translate}}</h6>
        <div class="edit-icons" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content flex-grow-1 w-100  ">
        <form action="" class=" d-flex flex-column justify-content-between" [formGroup]="addForm" (ngSubmit)="onSubmit()">
            <div class="scroll-c w-100">
                <input type="text" placeholder="{{ 'COMMON.ENTER' | translate }}  {{ 'COMMON.TITLE' | translate }}"
                    class="form-control mt-3 mt-md-4" formControlName="tit">
                <div>
                    <mat-error *ngIf="isControlHasError('tit','required')"> {{"COMMON.THR"|translate}}</mat-error>
                    <mat-error *ngIf="isControlHasError('tit','maxlength')"> {{"VALIDATION.MAXL"|translate}}</mat-error>
                </div>
                <textarea name="" id="" cols="10" rows="6" class="mt-3 mt-md-4 form-control" formControlName="notes"
                    placeholder="{{ 'COMMON.ENTER' | translate }} {{'COMMON.DESC'|translate}}"></textarea>
                    
                <mat-error *ngIf="isControlHasError('notes','required')"> {{"COMMON.THR"|translate}}</mat-error>    
                <div class="drop-box m-auto  mt-3 mt-md-4" style="width: 100% !important;">
                    <ngx-dropzone class="drop-item" (change)="onSelect($event)" [multiple]="false" accept="application/pdf">
                        <ngx-dropzone-label>
                            <div class="d-box">
                                <div class="me">
                                    <img src="assets/images/apps/upload_file.svg" class="img-fluid" alt="">
                                </div>
                                <div>
                                    <div class="text-left">{{"COMMON.CTU" | translate}}</div>
                                    <div class="upload-text text-left">{{"COMMON.DD" | translate}}</div>
                                </div>
                            </div>
                        </ngx-dropzone-label>
                        <ngx-dropzone-preview *ngFor="let f of files" (removed)="onRemove(f)" [removable]="true">
                            <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                        </ngx-dropzone-preview>
                    </ngx-dropzone>
                </div>
            </div>
        </form>
    </div>
    <div class="d-flex justify-content-center align-items-center item-footer">
        <button mat-raised-button color="primary" class="auth-form-btn  no-sh-btn mt-3" type="submit" (click)="onSubmit()">{{"Save"|translate}}</button>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>